import { honeycombLogoSvg, honeycombLogoSvgSource } from '@/assets/imagesBase64Str'

const PGM = {
  name: 'PGM',
  logo: honeycombLogoSvg(),
  address: '3103 W Lincoln St|Phoenix, AZ 85009',
  shipping: '3103 W Lincoln St|Phoenix, AZ 85009',
  phone: '(602) 258-6500',
  svg: honeycombLogoSvgSource
}

const HC = {
  name: 'Honeycomb',
  logo: honeycombLogoSvg(),
  address: '2185 Montee Masson|Laval, QC H7E 4P2',
  shipping: '2185 Montee Masson|Laval, QC H7E 4P2',
  phone: '(602) 258-6500',
  svg: honeycombLogoSvgSource
}
export const CONFIGS = {
  PGM,
  HC
}

const HOST_CONFIG = {
  'app.trackkat.com': Object.assign({}, PGM, {
    api: 'https://app.backend.trackkat.com',
    frontend: 'https://app.backend.trackkat.com',
    name: 'Trackkat'
  }),
  'sandbox.trackkat.com': Object.assign({}, PGM, {
    api: 'https://sandbox.backend.trackkat.com',
    frontend: 'https://sandbox.backend.trackkat.com',
    name: 'Sandbox'
  }),
  'localhost': Object.assign({}, PGM, {
    api: 'http://localhost:8000',
    frontend: 'http://localhost:8000',
    name: 'Development'
  })
}

let config = HOST_CONFIG['localhost']
let url = new URL(window.location.href)
if (HOST_CONFIG[url.hostname]) config = HOST_CONFIG[url.hostname]

export default config
